export interface Page {
  key: number;
  icon: string;
  title: string;
  href: string;
  iconClass?: boolean;
  protected?: boolean;
  tkey: string;
}

//tkey is for i18n translations
export const publicPagesExplore: Page[] = [
  {
    key: 1,
    icon: 'SatelliteOutlinedIcon',
    title: 'Order Imagery',
    href: '/',
    tkey: 'orderImagery',
  },
  ...(process.env.NEXT_PUBLIC_SHOW_PROVIDER && process.env.NEXT_PUBLIC_SHOW_PROVIDER === 'true'
    ? [
        {
          key: 2,
          icon: 'icon-provider',
          iconClass: true,
          title: 'Product Library',
          href: '/product-library',
          tkey: 'productLibrary',
        },
      ]
    : []),
  {
    key: 3,
    icon: 'SatelliteAltOutlinedIcon',
    title: 'Enterprise Features',
    href: '/enterprise-features',
    tkey: 'enterpriseFeatures',
  },
];

export const publicPagesHub: Page[] = [];

export const protectedPagesExplore: Page[] = [
  {
    key: 1,
    icon: 'SatelliteOutlinedIcon',
    title: 'Order Imagery',
    href: '/',
    protected: false,
    tkey: 'orderImagery',
  },
  {
    key: 2,
    icon: 'UpdateOutlinedIcon',
    title: 'My Orders',
    href: '/my-orders',
    protected: true,
    tkey: 'myOrders',
  },
  ...(process.env.NEXT_PUBLIC_SHOW_PROVIDER && process.env.NEXT_PUBLIC_SHOW_PROVIDER === 'true'
    ? [
        {
          key: 3,
          icon: 'icon-provider',
          iconClass: true,
          title: 'Product Library',
          href: '/product-library',
          protected: false,
          tkey: 'productLibrary',
        },
      ]
    : []),
  {
    key: 4,
    icon: 'SatelliteAltOutlinedIcon',
    title: 'Enterprise Features',
    href: '/enterprise-features',
    protected: false,
    tkey: 'enterpriseFeatures',
  },
];

export const protectedPagesHub: Page[] = [
  {
    key: 1,
    icon: 'SatelliteOutlinedIcon',
    title: 'Order Imagery',
    href: '/',
    protected: true,
    tkey: 'orderImagery',
  },
  {
    key: 2,
    icon: 'SatelliteAltOutlinedIcon',
    title: 'Projects',
    href: '/projects',
    protected: true,
    tkey: 'projects',
  },
  {
    key: 3,
    icon: 'PublicIcon',
    title: 'Data Management',
    href: '/data-management',
    protected: true,
    tkey: 'dataManagement',
  },
  {
    key: 4,
    icon: 'icon-organization',
    iconClass: true,
    title: 'Organization',
    href: '/organization',
    protected: true,
    tkey: 'organization',
  },
  {
    key: 5,
    icon: 'icon-approval',
    iconClass: true,
    title: 'Approvals',
    href: '/approvals',
    protected: true,
    tkey: 'approvals',
  },
  {
    key: 6,
    icon: 'icon-usage',
    iconClass: true,
    title: 'Metrics',
    href: '/metrics',
    protected: true,
    tkey: 'metrics',
  },
  {
    key: 7,
    icon: 'SettingsOutlinedIcon',
    title: 'Processing',
    href: '/processing',
    protected: true,
    tkey: 'processing',
  },
  ...(process.env.NEXT_PUBLIC_SHOW_PROVIDER === 'true'
    ? [
        {
          key: 8,
          icon: 'icon-provider',
          iconClass: true,
          title: 'Product Library',
          href: '/product-library',
          protected: true,
          tkey: 'productLibrary',
        },
      ]
    : []),
];
